"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LunarMineUrbanization = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const CardRenderer_1 = require("../render/CardRenderer");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const TileType_1 = require("../../TileType");
const Resources_1 = require("../../Resources");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const Card_1 = require("../Card");
const CardRequirements_1 = require("../CardRequirements");
const Units_1 = require("../../Units");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
class LunarMineUrbanization extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.LUNAR_MINE_URBANIZATION,
            cardType: CardType_1.CardType.EVENT,
            tags: [Tags_1.Tags.MOON, Tags_1.Tags.BUILDING],
            cost: 8,
            productionBox: Units_1.Units.of({ megacredits: 1 }),
            tr: { moonColony: 1 },
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.miningTiles(1)),
            metadata: {
                description: 'Requires that you have 1 mine tile on the Moon. Increase your M€ production 1 step. Replace one of your mine tiles ' +
                    'with this special tile. Raise the Colony Rate 1 step. This tile counts both as a colony and a mine tile.',
                cardNumber: 'M55',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.megacredits(1));
                    b.moonColonyRate();
                    b.tile(TileType_1.TileType.LUNAR_MINE_URBANIZATION, true).asterix();
                }),
            },
        });
    }
    ;
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (!super.canPlay(player))
            return false;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, true, false, false, false, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 1);
        const tiles = MoonExpansion_1.MoonExpansion.tiles(player.game, TileType_1.TileType.MOON_MINE, { ownedBy: player });
        return new SelectSpace_1.SelectSpace('Select one of your mines to upgrade', tiles, TileType_1.TileType.LUNAR_MINE_URBANIZATION, (space) => {
            if (space.tile === undefined) {
                throw new Error(`Space ${space.id} should have a tile, how doesn't it?`);
            }
            space.tile.tileType = TileType_1.TileType.LUNAR_MINE_URBANIZATION;
            space.tile.card = this.name;
            MoonExpansion_1.MoonExpansion.raiseColonyRate(player);
            return undefined;
        });
    }
    getActionDetails(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainProductionFromMoonTrackIncrease(this.tr) ? 2 : 0;
        return new RedsPolicy_1.ActionDetails({ card: card, moonColonyRateIncrease: 1, bonusMegaCredits: bonusMegaCredits });
    }
}
exports.LunarMineUrbanization = LunarMineUrbanization;
//# sourceMappingURL=LunarMineUrbanization.js.map